import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

/**
 * Masked line-by-line reveal. Pass `lines` (array of strings) or children per line.
 */
export const RevealLines = ({ lines = [], className = "", delay = 0, stagger = 0.12 }) => {
  return (
    <span className="block">
      {lines.map((line, i) => (
        <span key={i} className="text-line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
          >
            <span className={className}>{line}</span>
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
